import { cn } from "@/components/libs/cn";
import { type ReactNode } from "react";

interface GradientTextProps {
  children: ReactNode;
  colors: string[];
  className?: string;
}

export function GradientText({
  children,
  colors,
  className,
}: GradientTextProps) {
  const gradientStyle = {
    background: `linear-gradient(to right, ${colors.join(", ")})`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  };

  return (
    <span className={cn("bg-clip-text", className)} style={gradientStyle}>
      {children}
    </span>
  );
}

interface StylishTextProps {
  children: ReactNode;
  className?: string;
}

export function StylishText({ children, className }: StylishTextProps) {
  return (
    <GradientText
      colors={[
        "#8B5CF6",
        // "#3B82F6", "#06B6D4",
        "#EC4899",
      ]}
      className={className}
    >
      {children}
    </GradientText>
  );
}
